// extracted by mini-css-extract-plugin
module.exports = {"bannerBackground":"TopBanner_bannerBackground__32IJM"};